import { render, staticRenderFns } from "./ruralRoadAutoDetection.vue?vue&type=template&id=50a7d9de&scoped=true"
import script from "./ruralRoadAutoDetection.vue?vue&type=script&lang=js"
export * from "./ruralRoadAutoDetection.vue?vue&type=script&lang=js"
import style0 from "./ruralRoadAutoDetection.vue?vue&type=style&index=0&id=50a7d9de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7d9de",
  null
  
)

export default component.exports